var ABD = {
  _token: $.jStorage.get("localToken"),
  queryObj: {
    page: 1
  },
  pageInfo: null
};

ABD.init = function() {
  ABD.getAlbumProjectList(ABD.queryObj, ABD.renderList);
  UTL.reachBottom(ABD.reachBottomCb);
};

ABD.reachBottomCb = function() {
  if (!ABD.pageInfo) return;
  if (ABD.queryObj.page >= ABD.pageInfo.pages && ABD.pageInfo.totalCount > 0) {
    $(`.bottom-line`).slideDown();
    return;
  }
  ABD.queryObj.page++;
  ABD.getAlbumProjectList(ABD.queryObj, ABD.renderList);
};

ABD.getAlbumProjectList = function(query, cb) {
  showLoadingGif();
  $.ajax({
    url: v1url + PAY.api.getAlbumProjectList,
    type: "GET",
    data: query,
    headers: {
      token: ABD._token
    },
    dataType: "json",
    success: function(data) {
      if (data.code == 1000) {
        var data = data.data;
        ABD.pageInfo = data._pageinfo;
        cb && cb(data.items);
        closeLoadingGif();
      } else if (data.code == -1) {
        UTL.showPCLoginForm();
      } else if (data.code == 1006) {
        $("#payModal").modal("show");
      }
    },
    error: function() {}
  });
};

ABD.renderList = function(list) {
  list = list || [];
  // console.log(list);
  var $albumProjectListWrap = $("#albumProjectList");
  var _html = "";
  for (var i = 0, len = list.length; i < len; i++) {
    var item = list[i];
    _html += `
            <li class="project-item li-border">
                <div class="img-info">
                    <div class="img-wrap">
                    <a target="_blank" href="/projectdetail/${
                      item.id
                    }?from=album_list">
                        <img src=${
                          item.logo_url
                            ? `${item.logo_url}`
                            : "../../imgs/pay/common/bird.png"
                        } alt="">
                        </a>
                    </div>
                    ${
                      item.is_round == 1
                        ? '<p class="round-status">正在融资</p>'
                        : ""
                    }
                </div>
                <div class="project-info">
                    <div class="project-base-info">
                        <div class="col-item col-1">
                            <div class="base-info">
                                <div class="project-name">
                                    <div class="name"><a target="_blank" href="/projectdetail/${
                                      item.id
                                    }?from=album_list">${item.name}</a></div>
                                    ${
                                      false
                                        ? ' <div class="pencilnews-report pencilnews-report-style">铅笔道报道</div>'
                                        : ""
                                    }
                                </div>
                                <div class="introduce">${
                                  item.introduce ? item.introduce : ""
                                }</div>
                                
                            </div>
                        </div>
                        <div class="col-item col-2 industry">
                        ${
                          item.industry && item.industry[0]
                            ? `<p>${item.industry[0]}</p>`
                            : ""
                        }
                        
                        </div>
                        <div class="col-item col-3 address">${
                          item.office_address
                            ? PAY.extractCity(item.office_address)
                            : ""
                        }</div>
                        <div class="col-item col-4 round">${
                          item.stage_name ? item.stage_name : ""
                        }</div>
                        </div>
                    ${
                      item.bright_label_string
                        ? `<div class="tag" id="label-string">${
                            item.bright_label_string
                          }</div>`
                        : ""
                    }
                    ${
                      item.is_round == 1
                        ? `<div class="round-need">
                        ${PAY.getTarRoundString(
                          item.finance_round_name,
                          item.finance_money
                        )}
                        </div>`
                        : ""
                    }
                    
                    
                </div>
            </li>`;
  }
  $albumProjectListWrap.append(_html);
};
